export default __webpack_public_path__ + "static/media/icons8-member-48.1cad3459.svg";